<template>
  <div class="flex flex-col items-center bg-blue-7 rounded-xl pt-7 pb-14 px-6">
    <div class="h-12 mb-6 flex flex-col justify-center items-center">
      <slot name="icon" />
    </div>
    <b-headline type="h2" typography="h1" :responsive="false" class="mb-2 text-center">
      <slot name="title" />
    </b-headline>
    <div class="text-dark-grey text-center">
      <slot name="details" />
    </div>
  </div>
</template>

<script>
import BHeadline from "@/component-library/b-headline"
export default {
  name: "GrowthCard",
  components: {
    BHeadline
  }
}
</script>
